import React from 'react';
import AvatarDialog from '../../component/avatar/avatar-dialog';
import lightTemp1 from '../../static/qop-code-templates/light-template-demo-1.jpg';
import lightTemp2 from '../../static/qop-code-templates/light-template-demo-2.jpg';
import lightTemp3 from '../../static/qop-code-templates/light-template-demo-3.jpg';
import darkTemp1 from '../../static/qop-code-templates/dark-template-demo-1.jpg';
import darkTemp2 from '../../static/qop-code-templates/dark-template-demo-2.jpg';
import darkTemp3 from '../../static/qop-code-templates/dark-template-demo-3.jpg';

type PreviewTemplateForQopProps = {
    /** 是否打开 */
    open: boolean;
    /** 浅/深主题 */
    theme: 'light' | 'dark';
    /** 扫码方式 1 内网 2 公网 3 双码 */
    codeType: number;
    /** 关闭回调 */
    onClose: () => void;
};

/**
 * QOP 模板版式预览弹窗，与 RBP2 `PreviewTemplateForQOP` 一致。
 */
export function PreviewTemplateForQop(props: PreviewTemplateForQopProps): React.ReactElement {
    const { open, theme, codeType, onClose } = props;

    /**
     * 按扫码方式与主题选取示意大图。
     */
    const getTemp = (): string => {
        switch (codeType) {
            case 1:
                return theme === 'light' ? lightTemp1 : darkTemp1;
            case 2:
                return theme === 'light' ? lightTemp2 : darkTemp2;
            case 3:
                return theme === 'light' ? lightTemp3 : darkTemp3;
            default:
                return theme === 'light' ? lightTemp1 : darkTemp1;
        }
    };

    return (
        <AvatarDialog
            open={open}
            onClose={onClose}
            data={[
                {
                    imgSrc: getTemp(),
                    imgName: '',
                },
            ]}
        />
    );
}
